const ERROR = {
  userAuth: "*** User authorization error ***",
};

export default ERROR;
